import { Checkbox, Divider, Form, Input, InputNumber } from "antd"
import React from "react"

interface EmailSmtpImapCoreProps {
  disabled?: boolean
}

function EmailSmtpImapCore(props: EmailSmtpImapCoreProps) {
  const { disabled } = props
  return (
    <div className="">
      <Form.Item label="Descrição" name="description">
        <Input />
      </Form.Item>
      {/* <Divider
        className="my-6"
        style={{
          borderTop: "2px dashed var(--selected)",
        }}
      /> */}

      <div
        style={{
          "--input-background": "var(--base-100)",
        } as any}
      >
        <Form.Item label="IMAP">
          <div className="grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-2 bg-selected-lighter rounded-xl p-5">
            <Form.Item
              label="IMAP Host"
              name={["extraData", "imapData", "host"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item
              label="IMAP Porta"
              name={["extraData", "imapData", "port"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <InputNumber disabled={disabled} className="w-full" />
            </Form.Item>
            <Form.Item
              label="IMAP Usuário"
              name={["extraData", "imapData", "auth", "user"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item
              label="IMAP Senha"
              name={["extraData", "imapData", "auth", "pass"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Input.Password disabled={disabled} />
            </Form.Item>
            <Form.Item name={["extraData", "imapData", "secure"]} valuePropName="checked">
              <Checkbox disabled={disabled}>TLS/SSL</Checkbox>
            </Form.Item>
          </div>
        </Form.Item>

        {/* <Divider
        style={{
          borderTop: "2px dashed var(--selected)",
        }}
      /> */}
        <Form.Item label="SMTP">
          <div className="grid grid-cols-[repeat(auto-fit,_minmax(200px,_1fr))] gap-2 bg-selected-lighter rounded-xl p-5">
            <Form.Item
              label="SMTP Host"
              name={["extraData", "smtpData", "host"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item
              label="SMTP Porta"
              name={["extraData", "smtpData", "port"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <InputNumber disabled={disabled} className="!w-full" />
            </Form.Item>
            <Form.Item
              label="SMTP Usuário"
              name={["extraData", "smtpData", "auth", "user"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Input disabled={disabled} />
            </Form.Item>
            <Form.Item
              label="SMTP Senha"
              name={["extraData", "smtpData", "auth", "pass"]}
              rules={[{ required: true, message: "Campo obrigatório" }]}
            >
              <Input.Password disabled={disabled} />
            </Form.Item>

            <Form.Item name={["extraData", "smtpData", "secure"]} valuePropName="checked">
              <Checkbox disabled={disabled}>TLS/SSL</Checkbox>
            </Form.Item>
          </div>
        </Form.Item>
      </div>
    </div>
  )
}

export default EmailSmtpImapCore
